import { render, staticRenderFns } from "./AllOfficeDataCollectionStats.vue?vue&type=template&id=b8fd2c58&scoped=true"
import script from "./AllOfficeDataCollectionStats.vue?vue&type=script&lang=js"
export * from "./AllOfficeDataCollectionStats.vue?vue&type=script&lang=js"
import style0 from "./AllOfficeDataCollectionStats.vue?vue&type=style&index=0&id=b8fd2c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fd2c58",
  null
  
)

export default component.exports